(function () {
  const ROOT = document.querySelector('.b101-guia');
  if (!ROOT) return;
  // Visible strings come from the theme locales (data-i18n), Spanish as fallback.
  let T = {};
  try { T = JSON.parse(ROOT.dataset.i18n || '{}'); } catch (e) { T = {}; }
  const L = (k, d) => (typeof T[k] === 'string' ? T[k] : d);

  /* ---------- utilidades ---------- */
  let seed = 20260904;
  const rnd = () => (seed = (seed * 1664525 + 1013904223) % 4294967296) / 4294967296;
  const gauss = () => {
    const u = Math.max(rnd(), 1e-9), v = rnd();
    return Math.sqrt(-2 * Math.log(u)) * Math.cos(2 * Math.PI * v);
  };
  const SVGNS = 'http://www.w3.org/2000/svg';
  const $ = id => ROOT.querySelector('#' + id);
  function el(tag, attrs, parent) {
    const n = document.createElementNS(SVGNS, tag);
    for (const k in attrs) n.setAttribute(k, attrs[k]);
    if (parent) parent.appendChild(n);
    return n;
  }
  const clear = n => { while (n.firstChild) n.removeChild(n.firstChild); };
  function bellPath(cx, sigmaPx, baseY, height, x0, x1) {
    let d = '';
    for (let x = x0; x <= x1; x += 3) {
      const z = (x - cx) / sigmaPx;
      const y = baseY - height * Math.exp(-0.5 * z * z);
      d += (d ? 'L' : 'M') + x.toFixed(1) + ' ' + y.toFixed(1);
    }
    return d + 'L' + x1 + ' ' + baseY + 'L' + x0 + ' ' + baseY + 'Z';
  }
  function axisLine(svg, x0, x1, y) {
    el('line', { x1: x0, y1: y, x2: x1, y2: y, stroke: 'var(--rule)', 'stroke-width': 1 }, svg);
  }
  function tick(svg, x, y, label) {
    el('line', { x1: x, y1: y, x2: x, y2: y + 5, stroke: 'var(--rule)', 'stroke-width': 1 }, svg);
    const t = el('text', { x: x, y: y + 18, 'text-anchor': 'middle', fill: 'var(--ink-3)',
      'font-family': 'var(--mono)', 'font-size': 11 }, svg);
    t.textContent = label;
  }

  /* ---------- F1 - mediciones acumuladas ---------- */
  (function () {
    const f1 = $('f1'); if (!f1) return;
    const TRUE_V = 4.107, NOISE = 0.0045;
    let shots = [];
    function draw() {
      clear(f1);
      const x0 = 40, x1 = 600, base = 158;
      const lo = TRUE_V - 5 * NOISE, hi = TRUE_V + 5 * NOISE;
      const px = v => x0 + (v - lo) / (hi - lo) * (x1 - x0);
      axisLine(f1, x0, x1, base);
      [lo + (hi - lo) * 0.1, TRUE_V, hi - (hi - lo) * 0.1].forEach(v => tick(f1, px(v), base, v.toFixed(3)));
      const bins = 34, counts = new Array(bins).fill(0);
      shots.forEach(v => {
        const b = Math.max(0, Math.min(bins - 1, Math.floor((v - lo) / (hi - lo) * bins)));
        const y = base - 8 - counts[b] * 11;
        counts[b]++;
        el('circle', { cx: x0 + (b + 0.5) / bins * (x1 - x0), cy: y, r: 4.2, fill: 'var(--s2)', opacity: 0.9 }, f1);
      });
      if (shots.length) {
        const m = shots.reduce((a, b) => a + b, 0) / shots.length;
        el('line', { x1: px(m), y1: base + 2, x2: px(m), y2: 24, stroke: 'var(--s1)', 'stroke-width': 2 }, f1);
        const t = el('text', { x: px(m) + 7, y: 30, fill: 'var(--s1)', 'font-family': 'var(--mono)', 'font-size': 11 }, f1);
        t.textContent = L('mean', 'promedio');
        $('f1-mean').textContent = m.toFixed(4);
        $('f1-range').textContent = Math.min.apply(null, shots).toFixed(3) + ' / ' + Math.max.apply(null, shots).toFixed(3);
      } else {
        $('f1-mean').textContent = '—';
        $('f1-range').textContent = '—';
      }
      $('f1-n').textContent = shots.length;
    }
    const add = n => { for (let i = 0; i < n; i++) shots.push(TRUE_V + gauss() * NOISE); draw(); };
    $('f1-one').onclick = () => add(1);
    $('f1-many').onclick = () => add(20);
    $('f1-reset').onclick = () => { shots = []; draw(); };
    add(8);
  })();

  /* ---------- F2 - bandas sigma ---------- */
  (function () {
    const svg = $('f2'); if (!svg) return;
    const x0 = 40, x1 = 600, base = 160, cx = (x0 + x1) / 2, s = 62;
    [[3, 0.10, '99.7%'], [2, 0.14, '95%'], [1, 0.20, '68%']].forEach(function (b) {
      const k = b[0];
      el('rect', { x: cx - k * s, y: 26, width: 2 * k * s, height: base - 26, fill: 'var(--s1)', opacity: b[1] }, svg);
      const t = el('text', { x: cx + k * s - 4, y: 22 + (3 - k) * 15, 'text-anchor': 'end',
        fill: 'var(--ink-3)', 'font-family': 'var(--mono)', 'font-size': 11 }, svg);
      t.textContent = b[2];
    });
    el('path', { d: bellPath(cx, s, base, 120, x0, x1), fill: 'none', stroke: 'var(--s1)', 'stroke-width': 2 }, svg);
    axisLine(svg, x0, x1, base);
    for (let k = -3; k <= 3; k++) tick(svg, cx + k * s, base, k === 0 ? L('center', 'centro') : (k > 0 ? '+' : '') + k + 'σ');
    el('line', { x1: cx - 3 * s, y1: 196, x2: cx + 3 * s, y2: 196, stroke: 'var(--s2)', 'stroke-width': 2 }, svg);
    const t = el('text', { x: cx, y: 191, 'text-anchor': 'middle', fill: 'var(--s2)', 'font-family': 'var(--mono)', 'font-size': 12 }, svg);
    t.textContent = L('full_width', '6σ — el ancho completo');
  })();

  /* ---------- F3a - triangulo ---------- */
  (function () {
    const svg = $('f3tri'); if (!svg) return;
    const ox = 200, oy = 155, u = 26;
    el('path', { d: 'M' + ox + ',' + oy + ' L' + (ox + 4 * u) + ',' + oy + ' L' + ox + ',' + (oy - 3 * u) + ' Z',
      fill: 'var(--s1-f)', stroke: 'var(--s1)', 'stroke-width': 2 }, svg);
    el('path', { d: 'M' + ox + ' ' + (oy - 12) + ' L' + (ox + 12) + ' ' + (oy - 12) + ' L' + (ox + 12) + ' ' + oy,
      fill: 'none', stroke: 'var(--rule)', 'stroke-width': 1.5 }, svg);
    const lab = (x, y, txt, color, anchor) => {
      const t = el('text', { x: x, y: y, fill: color, 'text-anchor': anchor || 'middle',
        'font-family': 'var(--mono)', 'font-size': 13 }, svg);
      t.textContent = txt;
    };
    lab(ox + 2 * u, oy + 20, L('tri_noise', 'ruido del equipo = 4'), 'var(--s2)');
    lab(ox - 10, oy - 1.5 * u, L('tri_product', 'producto = 3'), 'var(--s1)', 'end');
    lab(ox + 2.4 * u + 14, oy - 1.7 * u, L('tri_seen', 'lo que ves = 5'), 'var(--ink)', 'start');
    lab(470, 90, '√(3² + 4²) = 5', 'var(--ink-2)', 'start');
    lab(470, 112, 'no 3 + 4 = 7', 'var(--ink-3)', 'start');
  })();

  /* ---------- F3b - suma de dispersiones ---------- */
  (function () {
    const svg = $('f3'); if (!svg) return;
    const P = $('f3-p'), M = $('f3-m');
    function draw() {
      clear(svg);
      const p = +P.value, m = +M.value, o = Math.sqrt(p * p + m * m);
      $('f3-po').textContent = p.toFixed(1);
      $('f3-mo').textContent = m.toFixed(1);
      $('f3-obs').textContent = o.toFixed(1);
      $('f3-inf').textContent = '+' + Math.round((o / p - 1) * 100) + '%';
      const x0 = 40, x1 = 600, cx = (x0 + x1) / 2, base = 200, scale = 26;
      [[p, 'var(--s1)', 'var(--s1-f)'], [m, 'var(--s2)', 'var(--s2-f)'], [o, 'var(--ink-3)', 'none']]
        .forEach(function (c) {
          el('path', { d: bellPath(cx, Math.max(c[0] * scale, 3), base, 150, x0, x1),
            fill: c[2], stroke: c[1], 'stroke-width': 2, 'stroke-linejoin': 'round' }, svg);
        });
      axisLine(svg, x0, x1, base);
      const t = el('text', { x: cx, y: base + 22, 'text-anchor': 'middle', fill: 'var(--ink-3)',
        'font-family': 'var(--mono)', 'font-size': 11 }, svg);
      t.textContent = L('measured_value', 'valor medido');
    }
    P.oninput = M.oninput = draw; draw();
  })();

  /* ---------- F4 - presupuesto de ruido (Cg / Cgk) ---------- */
  (function () {
    const svg = $('f4'); if (!svg) return;
    const N = $('f4-n'), B = $('f4-b');
    const LSL = 3.80, USL = 4.20, T = USL - LSL, MID = (LSL + USL) / 2;
    function draw() {
      clear(svg);
      const sigma = +N.value / 1000, bias = +B.value / 1000;
      const cg = (0.2 * T) / (6 * sigma);
      const cgk = (0.1 * T - Math.abs(bias)) / (3 * sigma);
      $('f4-no').textContent = sigma.toFixed(3);
      $('f4-bo').textContent = (bias >= 0 ? '+' : '') + bias.toFixed(3);
      $('f4-cg').textContent = cg.toFixed(2);
      $('f4-cgk').textContent = cgk.toFixed(2);
      const worst = Math.min(cg, cgk);
      $('f4-verd').innerHTML = worst >= 1.33 ? '<span class="pill ok">' + L('capable', 'Capaz') + '</span>'
        : worst >= 1 ? '<span class="pill mid">' + L('conditional', 'Condicional') + '</span>'
        : '<span class="pill no">' + L('not_capable', 'No capaz') + '</span>';
      const x0 = 40, x1 = 600, base = 170;
      const lo = LSL - 0.02, hi = USL + 0.02, px = val => x0 + (val - lo) / (hi - lo) * (x1 - x0);
      el('rect', { x: px(LSL), y: 22, width: px(USL) - px(LSL), height: base - 22, fill: 'var(--surface-2)' }, svg);
      const half = 0.1 * T;
      el('rect', { x: px(MID - half), y: 22, width: px(MID + half) - px(MID - half),
        height: base - 22, fill: 'var(--s1-f)', stroke: 'var(--s1)', 'stroke-width': 1 }, svg);
      const lb = el('text', { x: px(MID), y: 16, 'text-anchor': 'middle', fill: 'var(--s1)',
        'font-family': 'var(--mono)', 'font-size': 11 }, svg);
      lb.textContent = L('budget', '20% de la tolerancia — el presupuesto del instrumento');
      const spx = Math.max((sigma / (hi - lo)) * (x1 - x0), 2);
      el('path', { d: bellPath(px(MID + bias), spx, base, 120, x0, x1),
        fill: 'var(--s2-f)', stroke: 'var(--s2)', 'stroke-width': 2 }, svg);
      axisLine(svg, x0, x1, base);
      tick(svg, px(LSL), base, 'LSL 3.80');
      tick(svg, px(MID), base, L('nominal', 'nominal'));
      tick(svg, px(USL), base, 'USL 4.20');
    }
    N.oninput = B.oninput = draw; draw();
  })();

  /* ---------- F5 - ndc ---------- */
  (function () {
    const svg = $('f5'); if (!svg) return;
    const N = $('f5-n');
    const truth = [3.87, 3.905, 3.945, 3.975, 4.00, 4.03, 4.06, 4.095, 4.13, 4.165];
    const PV = 0.0925;
    function draw() {
      clear(svg);
      const noise = +N.value / 1000 * 1.6;
      const x0 = 60, x1 = 600, lo = 3.78, hi = 4.22;
      const px = v => x0 + (v - lo) / (hi - lo) * (x1 - x0);
      truth.forEach(function (v, i) {
        const y = 18 + i * 20;
        const a = Math.max(px(v - 3 * noise), x0), b = Math.min(px(v + 3 * noise), x1);
        el('rect', { x: a, y: y - 5, width: Math.max(b - a, 3), height: 10, rx: 5, fill: 'var(--s1)', opacity: 0.55 }, svg);
        el('line', { x1: px(v), y1: y - 9, x2: px(v), y2: y + 9, stroke: 'var(--ink)', 'stroke-width': 2, opacity: 0.7 }, svg);
        const t = el('text', { x: x0 - 10, y: y + 4, 'text-anchor': 'end', fill: 'var(--ink-3)',
          'font-family': 'var(--mono)', 'font-size': 10 }, svg);
        t.textContent = L('board', 'tarjeta') + ' ' + (i + 1);
      });
      axisLine(svg, x0, x1, 222);
      [3.80, 4.00, 4.20].forEach(v => tick(svg, px(v), 222, v.toFixed(2) + ' V'));
      const ndc = Math.max(Math.floor(1.41 * (PV / noise)), 0);
      const grr = 100 * noise / Math.sqrt(noise * noise + PV * PV);
      $('f5-ndc').textContent = ndc;
      $('f5-grr').textContent = grr.toFixed(1) + '%';
      $('f5-no').textContent = noise < 0.02 ? L('low', 'bajo') : noise < 0.05 ? L('medium', 'medio') : L('high', 'alto');
      $('f5-verd').innerHTML = (grr < 10 && ndc >= 5) ? '<span class="pill ok">' + L('acceptable', 'Aceptable') + '</span>'
        : (grr < 30) ? '<span class="pill mid">' + L('conditional', 'Condicional') + '</span>'
        : '<span class="pill no">' + L('not_acceptable', 'No aceptable') + '</span>';
    }
    N.oninput = draw; draw();
  })();

  /* ---------- F6 - rejilla ANOVA ---------- */
  (function () {
    const g = $('f6'); if (!g) return;
    const ops = ['A', 'B', 'C'].map((x) => L('operator', 'Operador') + ' ' + x);
    const opShift = [0, 6, -5];
    const partVal = [4, 10, 16, 21, 26, 30, 35, 40, 45, 50];
    let html = '<div class="hd"></div>';
    for (let p = 0; p < 10; p++) html += '<div class="hd">' + L('part_prefix', 'T') + (p + 1) + '</div>';
    ops.forEach(function (o, oi) {
      html += '<div class="rh">' + o + '</div>';
      for (let p = 0; p < 10; p++) {
        let bars = '';
        for (let r = 0; r < 3; r++) {
          const h = Math.max(4, Math.min(28, partVal[p] * 0.5 + opShift[oi] + (rnd() - 0.5) * 6));
          bars += '<i style="height:' + h + 'px"></i>';
        }
        html += '<div class="cell" data-op="' + oi + '" data-part="' + p + '">' + bars + '</div>';
      }
    });
    g.innerHTML = html;
    const EXP = {
      ev: L('exp_ev_html', 'Las tres barritas de UNA celda son la misma tarjeta, el mismo operador, tres veces seguidas. Todo lo que difieran entre sí es del equipo — no hay nada más que pueda haber cambiado. Eso es la <strong>repetibilidad</strong>.'),
      av: L('exp_av_html', 'Compara una fila con otra: son las mismas diez tarjetas, medidas por personas distintas. Si una fila está sistemáticamente más alta, ese operador aporta variación. Eso es la <strong>reproducibilidad</strong>.'),
      pv: L('exp_pv_html', 'Compara una columna con otra: son tarjetas distintas. Que difieran es lo NORMAL y lo deseable — es la variación real del producto, y es contra ella que se mide todo lo demás.'),
      none: L('exp_none_html', 'Cada celda tiene tres barritas: son las tres veces que ese operador midió esa tarjeta. Los tres botones de arriba señalan de dónde sale cada componente.')
    };
    const cells = Array.prototype.slice.call(g.querySelectorAll('.cell'));
    const btns = Array.prototype.slice.call(ROOT.querySelectorAll('[data-mode]'));
    btns.forEach(function (btn) {
      btn.onclick = function () {
        const mode = btn.getAttribute('data-mode');
        btns.forEach(b => b.setAttribute('aria-pressed', String(b === btn)));
        cells.forEach(c => c.classList.remove('hi'));
        if (mode === 'ev') cells.filter(c => c.getAttribute('data-op') === '1' && c.getAttribute('data-part') === '4').forEach(c => c.classList.add('hi'));
        if (mode === 'av') cells.filter(c => c.getAttribute('data-op') !== '0').forEach(c => c.classList.add('hi'));
        if (mode === 'pv') cells.filter(c => c.getAttribute('data-part') === '2' || c.getAttribute('data-part') === '8').forEach(c => c.classList.add('hi'));
        $('f6-exp').innerHTML = EXP[mode];
      };
    });
  })();

  /* ---------- F8 - Cp vs Cpk ---------- */
  (function () {
    const svg = $('f8'); if (!svg) return;
    const C = $('f8-c'), S = $('f8-s');
    const LSL = 3.80, USL = 4.20;
    const erf = x => {
      const t = 1 / (1 + 0.3275911 * Math.abs(x));
      const y = 1 - ((((1.061405429 * t - 1.453152027) * t + 1.421413741) * t - 0.284496736) * t + 0.254829592) * t * Math.exp(-x * x);
      return x >= 0 ? y : -y;
    };
    const cdf = z => 0.5 * (1 + erf(z / Math.SQRT2));
    function draw() {
      clear(svg);
      const mu = 4.00 + +C.value / 1000, sg = +S.value / 1000;
      const cp = (USL - LSL) / (6 * sg);
      const cpk = Math.min((USL - mu), (mu - LSL)) / (3 * sg);
      const out = (cdf((LSL - mu) / sg) + (1 - cdf((USL - mu) / sg))) * 1e6;
      $('f8-co').textContent = mu.toFixed(3) + ' V';
      $('f8-so').textContent = sg.toFixed(3);
      $('f8-cp').textContent = cp.toFixed(2);
      const cpkEl = $('f8-cpk');
      cpkEl.textContent = cpk.toFixed(2);
      cpkEl.style.color = cpk >= 1.33 ? 'var(--good)' : cpk >= 1 ? 'var(--warn)' : 'var(--crit)';
      $('f8-ppm').textContent = out < 1 ? '<1 ppm' : Math.round(out).toLocaleString(L('number_locale', 'es-MX')) + ' ppm';
      const x0 = 40, x1 = 600, base = 168, lo = 3.72, hi = 4.28;
      const px = v => x0 + (v - lo) / (hi - lo) * (x1 - x0);
      el('rect', { x: px(LSL), y: 20, width: px(USL) - px(LSL), height: base - 20, fill: 'var(--s3)', opacity: 0.09 }, svg);
      [[LSL, 'LSL'], [USL, 'USL']].forEach(function (c) {
        el('line', { x1: px(c[0]), y1: 20, x2: px(c[0]), y2: base, stroke: 'var(--s3)', 'stroke-width': 2 }, svg);
        const t = el('text', { x: px(c[0]), y: 14, 'text-anchor': 'middle', fill: 'var(--s3)',
          'font-family': 'var(--mono)', 'font-size': 11 }, svg);
        t.textContent = c[1];
      });
      el('path', { d: bellPath(px(mu), (sg / (hi - lo)) * (x1 - x0), base, 128, x0, x1),
        fill: 'var(--s1-f)', stroke: 'var(--s1)', 'stroke-width': 2 }, svg);
      el('line', { x1: px(mu), y1: base, x2: px(mu), y2: base - 138, stroke: 'var(--s1)',
        'stroke-width': 1.5, 'stroke-dasharray': '3 3' }, svg);
      axisLine(svg, x0, x1, base);
      [3.80, 4.00, 4.20].forEach(v => tick(svg, px(v), base, v.toFixed(2)));
    }
    C.oninput = S.oninput = draw; draw();
  })();
})();
